import React, {useEffect, useRef, useState} from "react";
import HubIcon from '@mui/icons-material/Hub';
import Button from "@mui/material/Button";
import {
    Alert,
    debounce,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Fade, IconButton, Snackbar, Stack, Switch,
    ThemeProvider, Typography
} from "@mui/material";
import {DropDown, DropDownItem} from "./DropDown";
import CreateNewFolderSharpIcon from '@mui/icons-material/CreateNewFolderSharp';
import DriveFolderUploadSharpIcon from '@mui/icons-material/DriveFolderUploadSharp';
import SaveAsSharpIcon from '@mui/icons-material/SaveAsSharp';
import SaveSharpIcon from '@mui/icons-material/SaveSharp';
import BuildSharpIcon from '@mui/icons-material/BuildSharp';
import LocalLibrarySharpIcon from '@mui/icons-material/LocalLibrarySharp';
import QuestionMarkSharpIcon from '@mui/icons-material/QuestionMarkSharp';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import {AlertDialog, InformationDialog, SettingsDialog, StatsDialog} from "./Dialog";
import {readFileContent} from "./Globals";
import HelpIcon from '@mui/icons-material/Help';
import {d3_to_png} from "./Globals";
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PhotoIcon from '@mui/icons-material/Photo';
import * as d3 from "d3";
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import LightModeIcon from '@mui/icons-material/LightMode';
const EditMode = (props) => {
    return (
        <Stack direction="row" spacing={0} alignItems="center">
            <IconButton size="small" aria-label="editMode"
                        onClick={e => {
                            props.setOpenInformationDialog(true);
                        }}>
                <HelpIcon fontSize="medium" color="textColor"></HelpIcon>
            </IconButton>

            <Switch checked={props.editMode} value={props.editMode} color="success" onChange={e => {
                props.setEditMode(e.target.checked)
            }}/>
        </Stack>
    )
}

const UndoRedo = (props) => {
    return (
        <Stack direction="row" sx={{marginRight: 4}} alignItems="center">
            <IconButton size="small" aria-label="undo" disabled={props.historyStack.length === 0}
                        onClick={props.undoFunc} color="textColor">
                <UndoIcon fontSize="small"></UndoIcon>
            </IconButton>
            <IconButton size="small" aria-label="redo" disabled={props.futureStack.length === 0}
                        onClick={props.redoFunc} color="textColor">
                <RedoIcon fontSize="small"></RedoIcon>
            </IconButton>
        </Stack>
    )
}


const DarkMode = (props) => {
    return (
        <IconButton onClick={e => props.setDarkMode(!props.darkMode)}>
            <Fade in={props.darkMode} timeout={300}>
                <LightModeIcon style={{ position: 'absolute' }} />
            </Fade>
            <Fade in={!props.darkMode} timeout={300}>
                <NightsStayIcon color="textColor" />
            </Fade>
        </IconButton>
    );
}
const TopNavBar = (props) => {
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('success');
    const [openInformationDialog, setOpenInformationDialog] = useState(false);
    const [takingScreenshot, setTakingScreenshot] = useState(false);
    const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
    const [openStatsDialog, setOpenStatsDialog] = useState(false);

    const saveUserSettings = (nodeCol, highNodeCol, edgeCol, highEdgeCol,
                              nodeRadius, edgeWidth, nodeLabelCol, edgeLabelCol,
                              primaryColor, secondaryColor, edgeSocialSocial, edgeSocialSpatial,
                              edgeSettingsAdvanced, nodeSettingsSocial, nodeSettingsSpatial, nodeSettingsAdvanced) => {
        props.setStandardNodeColor(nodeCol);
        props.setStandardEdgeColor(edgeCol);
        props.setHighlightNodeColor(highNodeCol);
        props.setHighlightEdgeColor(highEdgeCol);
        props.setNodeRadius(nodeRadius);
        props.setEdgeWidth(edgeWidth);
        props.setNodeLabelColor(nodeLabelCol);
        props.setEdgeLabelColor(edgeLabelCol);
        props.setPrimaryColor(primaryColor);
        props.setSecondaryColor(secondaryColor);
        props.setEdgeSettingsSocialSocial(edgeSocialSocial);
        props.setEdgeSettingsSocialSpatial(edgeSocialSpatial);
        props.setEdgeSettingsAdvanced(edgeSettingsAdvanced);
        props.setNodeSettingsSocial(nodeSettingsSocial);
        props.setNodeSettingsSpatial(nodeSettingsSpatial);
        props.setNodeSettingsAdvanced(nodeSettingsAdvanced);

        setOpenSettingsDialog(false);
    }
    const takeScreenshot = () => {

        d3.select(`#node-${props.selectedObject?.id}`)
            .style('stroke', props.standardNodeColor);
        d3.select(`#edge-${props.selectedObject?.source?.id ?? props.selectedObject?.source}-${props.selectedObject?.target?.id ?? props.selectedObject?.target}`)
            .style('stroke', props.standardNodeColor)
            .attr('marker-end', d => d.directed ? 'url(#arrowhead)' : '');

        let svg = document.querySelector("#networkGraphSvg");
        let file;
        debugger
        const graph3d = document.getElementById('3dgraph');
        if(graph3d){
            file = graph3d.getElementsByTagName('canvas')[0].toDataURL(`image/png`);
        } else {
            file = d3_to_png(svg, "screenshot")
        }
        props.download("graph.png", file, ".png")
        d3.select(`#node-${props.selectedObject?.id}`)
            .style('stroke', props.hightlightNodeColor);
        d3.select(`#edge-${props.selectedObject?.source?.id ?? props.selectedObject?.source}-${props.selectedObject?.target?.id ?? props.selectedObject?.target}`)
            .style('stroke', props.highlightEdgeColor)
            .attr('marker-end', d => d.directed ? 'url(#arrowSelected)' : '');
    }

    const handleSaveProject = async () => {
        let projectJson = JSON.parse(JSON.stringify(props.jsonData));
        projectJson = props.saveUserConfig(projectJson);
        debugger
        let projectString = JSON.stringify(projectJson);
        await props.download('project.pr', projectString)
            .then(response => {
                setAlertMessage('Project successfully saved');
                setAlertSeverity('success');
                setOpenSnackbar(true);
                props.setUnsavedChanges(false);
            })
            .catch(error => {
                setAlertMessage('Project could not be saved');
                setAlertSeverity('error');
                setOpenSnackbar(true);
            })

    };
    const handleInitProject = () => {
        props.setJsonData({
            "nodes": [],
            "links": [],
        })
        props.setSelectedObject(null);
        props.propertiesToggle();
        setOpenConfirm(false);
        setAlertMessage('Project successfully initialized');
        setAlertSeverity('success');
        setOpenSnackbar(true);
        props.setUnsavedChanges(false);
    }
    const uploadRef = useRef();
    const handleUploadProject = async (projectFile) => {
        let tempJson = {"nodes": [], "links": [],}
        const projectContent = await readFileContent(projectFile);
        try {
            const projectJson = JSON.parse(projectContent);
            tempJson.nodes = projectJson.nodes;
            tempJson.links = projectJson.links;
            props.setUserConfig(projectJson);
            setAlertMessage('Project successfully loaded');
            setAlertSeverity('success');
            setOpenSnackbar(true);

        } catch (e) {
            debugger
            setAlertMessage('Project could not be loaded, selected wrong file or file is corrupted.');
            setAlertSeverity('error');
            setOpenSnackbar(true);
        }
        props.setJsonData(tempJson);
    }

    return (
        <ThemeProvider theme={props.theme}>
            <div
                className="flex flex-row items-center justify-between bg-neutral-100 dark:bg-neutral-700 w-full h-10 px-4 border-b-2 border-neutral-900">
                <Snackbar open={openSnackbar} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                          autoHideDuration={6000} onClose={e => setOpenSnackbar(false)}>
                    <Alert
                        onClose={e => setOpenSnackbar(false)}
                        severity={alertSeverity}
                        variant="filled"
                        sx={{width: '100%'}}
                    >
                        {alertMessage}
                    </Alert>
                </Snackbar>
                <SettingsDialog openSettingsDialog={openSettingsDialog}
                                setOpenSettingsDialog={setOpenSettingsDialog} theme={props.theme}
                                standardNodeColor={props.standardNodeColor}
                                primaryColor={props.primaryColor}
                                secondaryColor={props.secondaryColor}
                                highlightNodeColor={props.highlightNodeColor}
                                standardEdgeColor={props.standardEdgeColor}
                                highlightEdgeColor={props.highlightEdgeColor}
                                saveUserSettings={saveUserSettings}
                                nodeRadius={props.nodeRadius}
                                edgeWidth={props.edgeWidth}
                                nodeLabelColor={props.nodeFontColor}
                                edgeLabelColor={props.edgeFontColor}
                                edgeSettingsAdvanced={props.edgeSettingsAdvanced}
                                edgeSettingsSocialSpatial={props.edgeSettingsSocialSpatial}
                                edgeSettingsSocialSocial={props.edgeSettingsSocialSocial}
                                nodeSettingsSocial={props.nodeSettingsSocial}
                                nodeSettingsSpatial={props.nodeSettingsSpatial}
                                nodeSettingsAdvanced={props.nodeSettingsAdvanced}>
                </SettingsDialog>
                <StatsDialog openStatsDialog={openStatsDialog} setOpenStatsDialog={setOpenStatsDialog}
                             jsonData={props.jsonData} theme={props.theme}>
                </StatsDialog>
                <div className="flex flex-row justify-center items-center">
                    <HubIcon fontSize="small" color="textColor"></HubIcon>
                    <div className="mx-4 flex ">
                        <NavBarItem name={"Project"}>
                            <DropDown>
                                <DropDownItem name={"New"} onClick={e => {
                                    if (props.unsavedChanges) {
                                        setOpenConfirm(true)
                                    } else {
                                        handleInitProject();
                                    }
                                }}
                                              leftIcon={<CreateNewFolderSharpIcon
                                                  fontSize="small"></CreateNewFolderSharpIcon>}></DropDownItem>
                                <DropDownItem name={"Open ..."} onClick={e => uploadRef.current.click()}
                                              leftIcon={<DriveFolderUploadSharpIcon
                                                  fontSize="small"></DriveFolderUploadSharpIcon>}>
                                </DropDownItem>
                                <input
                                    type="file"
                                    ref={uploadRef}
                                    style={{display: 'none'}}
                                    onChange={e => handleUploadProject(e.target.files[0])}
                                />
                                <DropDownItem name={"Save ..."} onClick={handleSaveProject}
                                              leftIcon={<SaveSharpIcon
                                                  fontSize="small"></SaveSharpIcon>}></DropDownItem>

                            </DropDown>
                        </NavBarItem>
                        <NavBarItem name={"View"}>
                            <DropDown>
                                <DropDownItem name={"Toolbar"}
                                              onClick={props.toolBarToggle}
                                              toggable={true}
                                              isActive={props.showToolBar}
                                              leftIcon={<BuildSharpIcon
                                                  fontSize="small"></BuildSharpIcon>}></DropDownItem>
                                {props.selectedObject !== null &&
                                    <DropDownItem name={"Properties"}
                                                  toggable={true}
                                                  isActive={props.showProperties}
                                                  onClick={props.propertiesToggle}
                                                  leftIcon={<SearchIcon
                                                      fontSize="small"></SearchIcon>}>

                                    </DropDownItem>
                                }
                                <DropDownItem name={"Node labels"}
                                              onClick={e => props.setShowNodeLabels(!props.showNodeLabels)}
                                              toggable={true}
                                              isActive={props.showNodeLabels}>
                                </DropDownItem>
                                <DropDownItem name={"Edge Labels"}
                                              toggable={true}
                                              isActive={props.showEdgeLabels}
                                              onClick={e => props.setShowEdgeLabels(!props.showEdgeLabels)}></DropDownItem>
                                <DropDownItem name={"Layout settings"}

                                              onClick={e => setOpenSettingsDialog(true)}
                                              leftIcon={<TuneIcon
                                                  fontSize="small"></TuneIcon>}>
                                </DropDownItem>
                            </DropDown>
                        </NavBarItem>
                        <NavBarItem name={"Export"}>
                            <DropDown>
                                <DropDownItem name={"As Image ..."}
                                              leftIcon={<PhotoIcon fontSize="small"></PhotoIcon>}
                                              onClick={e => takeScreenshot()}></DropDownItem>
                                <DropDownItem name={"As GR/CO ..."} onClick={async e => {
                                    const downloadFiles = await props.handleExport();
                                    debugger
                                    const gr = downloadFiles[0];
                                    const co = downloadFiles[1];
                                    await props.download('project.gr', gr, '.gr');
                                    await props.download('project.co', co, '.co')
                                        .then(response => {
                                            setAlertMessage('Project successfully exported');
                                            setAlertSeverity('success');
                                            setOpenSnackbar(true);
                                        })
                                        .catch(error => {
                                            setAlertMessage('Project could not be exported');
                                            setAlertSeverity('error');
                                            setOpenSnackbar(true);
                                        })
                                }
                                }
                                              leftIcon={<ExitToAppIcon
                                                  fontSize="small"></ExitToAppIcon>}></DropDownItem>
                            </DropDown>
                        </NavBarItem>
                        <NavBarItem name={"Analytics"}>
                            <DropDown>
                                <DropDownItem name={"Network Statistics"}
                                              onClick={e => setOpenStatsDialog(true)}
                                              leftIcon={<QueryStatsIcon
                                                  fontSize="small"></QueryStatsIcon>}></DropDownItem>
                            </DropDown>
                        </NavBarItem>
                    </div>
                </div>
                <div className="flex">
                    <UndoRedo undoFunc={props.undoFunc} redoFunc={props.redoFunc}
                              historyStack={props.historyStack} futureStack={props.futureStack}>
                    </UndoRedo>
                    <EditMode editMode={props.editMode} setEditMode={props.setEditMode}
                              setOpenInformationDialog={setOpenInformationDialog}>
                    </EditMode>
                    <DarkMode darkMode={props.darkMode} setDarkMode={props.setDarkMode}></DarkMode>
                </div>
            </div>
            <AlertDialog openConfirm={openConfirm} setOpenConfirm={setOpenConfirm} onAccept={handleInitProject}>
                You have unsaved changes in your project. If you open a new project, these unsaved changes will be
                lost.

            </AlertDialog>
            <InformationDialog title="Edit Mode" openInformation={openInformationDialog}
                               setOpenInformation={setOpenInformationDialog}>
                When edit mode is enabled, you can add, move and delete nodes and edges. You can also change the
                properties of nodes and edges.
                If the edit mode is disabled, you can not edit the data of the graph.
            </InformationDialog>
        </ThemeProvider>
    );
}
const NavBarItem = (props) => {
    const [open, setOpen] = useState(false);
    const node = useRef();

    const handleClickOutside = (e) => {
        if (node.current.contains(e.target)) {
            return;
        }
        setOpen(false);
    };
    useEffect(() => {
        // Event-Listener hinzufügen, wenn das Dropdown-Menü geöffnet ist
        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        // Event-Listener entfernen, wenn die Komponente unmountet wird
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);

    return (
        <div ref={node}>
            <Button variant="text" color="textColor" sx={{textTransform: 'none', fontSize: '1em'}}
                    onClick={() => setOpen(!open)}>{props.name}</Button>
            {open && props.children}
        </div>
    )
}
export default TopNavBar;